import { BoolInput } from '../../atoms/bool-input.component';
import { RadioStyles } from './radio.styles';
import type { RadioOptionProps } from './types';

export const Radio = ({ active, checked, disabled, trackingId, ...rest }: RadioOptionProps) => {
  const radioStyles = RadioStyles.radio({ active, checked, disabled });
  return (
    <div className={radioStyles}>
      <BoolInput
        {...rest}
        aria-checked={checked}
        checked={checked}
        disabled={disabled}
        type='radio'
        data-trackingid={trackingId}
      />
    </div>
  );
};
